var _tspan, _tspan2, _tspan3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSueEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 473.74 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "#231f20",
      fontFamily: "Montserrat-Regular,Montserrat",
      fontSize: 26
    },
    transform: "translate(58.48 27.61)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "hello@sueboland")), /*#__PURE__*/React.createElement("tspan", {
    x: 227.76,
    y: 0,
    style: {
      letterSpacing: 0
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 242.16,
    y: 0,
    style: {
      letterSpacing: 0
    }
  }, "o"), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 258.39,
    y: 0
  }, "a")), /*#__PURE__*/React.createElement("tspan", {
    x: 273.73,
    y: 0,
    style: {
      letterSpacing: 0
    }
  }, "c"), _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 288.16,
    y: 0
  }, "hing")), /*#__PURE__*/React.createElement("tspan", {
    x: 348.11,
    y: 0,
    style: {
      letterSpacing: "-.01em"
    }
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 353.23,
    y: 0,
    style: {
      letterSpacing: 0
    }
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 367.64,
    y: 0,
    style: {
      letterSpacing: 0
    }
  }, "om")), /*#__PURE__*/React.createElement("path", {
    d: "M46.59 5.95H7.26c-.57 0-1.03.47-1.03 1.03v25.87c0 .57.47 1.03 1.03 1.03h39.33c.57 0 1.03-.47 1.03-1.03V6.99c0-.57-.47-1.03-1.03-1.03Zm-2.48 2.07L26.93 25.2 9.74 8.02H44.1ZM8.3 9.47l10.45 10.45L8.3 30.37V9.47Zm1.5 22.36 10.4-10.4 6 6c.41.41 1.03.41 1.45 0l6-6 10.4 10.4H9.79Zm35.76-1.45L35.11 19.93 45.56 9.48v20.91Z",
    style: {
      fill: "#010101"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M851.65-462.5v1684h-1784v-1684h1784m8-8h-1800v1700h1800v-1700Z",
    style: {
      fill: "#3a53a4"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSueEmail);
export default __webpack_public_path__ + "static/media/sue-email.78fa9d26abe79c410bb0784c173d71ef.svg";
export { ForwardRef as ReactComponent };